import { render } from "./ExportDetails.vue?vue&type=template&id=1a3c066e&scoped=true"
import script from "./ExportDetails.vue?vue&type=script&lang=js"
export * from "./ExportDetails.vue?vue&type=script&lang=js"

import "./ExportDetails.vue?vue&type=style&index=0&id=1a3c066e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3c066e"]])

export default __exports__